module.exports = __webpack_public_path__ + "img/no-data_setting.9d6fd8a4.svg";